import { AdminGuard } from './core/admin.guard';
import { LoginComponent } from './components/login/login.component';
import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/auth.guard';
import { KursantResolver } from './services/kursant.resolver';
import { GrupaResolver } from './services/grupa.resolver';

import { DashboardComponent } from './dashboard/dashboard.component';
import { KursanciComponent } from './kursanci/kursanci.component';
import { KursantDetailsComponent } from './kursanci/kursant-details/kursant-details.component';
import { KursantGrupaComponent } from './kursant-grupa/kursant-grupa.component';
import { GrupyComponent } from './grupy/grupy.component';
import { KursantNewComponent } from './kursant-new/kursant-new.component';
import { GrupaNewComponent } from './grupa-new/grupa-new.component';
import { GrupaDetailsComponent } from './grupy/grupa-details/grupa-details.component';

const routes: Routes = [
    { path: 'dashboard',                        component: DashboardComponent, canActivate: [AuthGuard] },
    { path: 'kursanci/kursant-details/:key',    component: KursantDetailsComponent, canActivate: [AuthGuard, AdminGuard], resolve: {kursant: KursantResolver} },
    { path: 'kursanci/kursant-details',         component: KursantDetailsComponent, canActivate: [AuthGuard, AdminGuard] },
    { path: 'kursanci',                         component: KursanciComponent, canActivate: [AuthGuard, AdminGuard]  },    
    { path: 'kursant-new',                      component: KursantNewComponent, canActivate: [AuthGuard, AdminGuard]  },
    { path: 'kursant-new/:key',                 component: KursantNewComponent, canActivate: [AuthGuard, AdminGuard]  },
    { path: 'kursant-grupa',                    component: KursantGrupaComponent, canActivate: [AuthGuard, AdminGuard]  },
    { path: 'kursant-grupa/:key',               component: KursantGrupaComponent, canActivate: [AuthGuard, AdminGuard]  },
    { path: 'grupy',                            component: GrupyComponent, canActivate: [AuthGuard, AdminGuard]  },
    { path: 'grupy/grupa-details/:key',         component: GrupaDetailsComponent, canActivate: [AuthGuard, AdminGuard], resolve: {grupa: GrupaResolver} },
    { path: 'grupa-new',                        component: GrupaNewComponent, canActivate: [AuthGuard, AdminGuard]  },
    { path: 'login',                            component: LoginComponent },
    
      { path: '', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
  ],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts